import { render, staticRenderFns } from "./ArrowChangeHorizontalOrder.vue?vue&type=template&id=1c8f7d1c&"
var script = {}


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports